import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $integrationsStore, $profileStore } from '@lib/store';
import { IntegrationList } from './widgets';
import { PageContainer, View } from '@widgets';

export const IntegrationsPage = () => {
  const profileStore = useUnit($profileStore.store);
  const integrationsStore = useUnit($integrationsStore.store);

  const { t } = useTranslation('integrations');

  useEffect(() => {
    $integrationsStore.events.getInitialIntegrations();
    return () => $integrationsStore.events.clear();
  }, [profileStore.data?.userType]);

  return (
    <PageContainer title={t('title')} header={t('header')}>
      <View
        loading={integrationsStore.loading}
        error={integrationsStore.error}
        noData={!integrationsStore.data.length}
        onRefresh={() => $integrationsStore.events.getInitialIntegrations()}
      >
        <IntegrationList list={integrationsStore.data} />
      </View>
    </PageContainer>
  );
};
